import { EXCHANGES, getMarketType } from "@cede/utils";

/**
 * Format pair symbol for Crypto.com WebSocket
 * Spot: BTC/USDT → BTC_USDT
 * Perps: BTC/USD:USD → BTCUSD-PERP
 */
export function formatCryptocomSymbol(pairSymbol: string): string {
  if (getMarketType(EXCHANGES.CRYPTOCOM, pairSymbol) === "perps") {
    const basePair = pairSymbol.split(":")[0] ?? pairSymbol;
    return basePair.replace("/", "") + "-PERP";
  }
  return pairSymbol.replace("/", "_");
}
